import { render, staticRenderFns } from "./QuestionTypeUpload.vue?vue&type=template&id=275d9df8&"
import script from "./QuestionTypeUpload.vue?vue&type=script&lang=js&"
export * from "./QuestionTypeUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports